import { Component, Prop, Vue } from 'vue-property-decorator';
import AsideMenuItem from '@/components/AsideMenuItem';
import { Menu } from '@/models';
import authenticator from '@/store/authentication';
import { authorizedMenus } from '@/filters';

@Component({
    components: { AsideMenuItem },
})
export default class AsideMenuList extends Vue {

    @Prop({ default: false }) private readonly isSubmenuList!: boolean;
    @Prop({ default: [] }) private readonly menu!: Menu[];

    private onSelectMenu(menu: Menu): void {
        this.$emit('onSelectMenu', menu);
    }

    get authorizedMenu(): Menu[] {
        return authorizedMenus(authenticator.userProfile, this.menu);
    }

}